import React from "react";
import "../styles/TheSimonProject.css";
import barra from "../assets/barra.png";
import simon from "../assets/simon.jpg";

const TheSimonProject = () => {
  return (
    <div className="simon-container">
      <h1>The Simon Project</h1>
      <h2>Tecnologia educacional. Com alma.</h2>
      <img src={barra} alt="Ambiente educacional" className="simon-image" />

      <p>
        O The Simon Project é uma plataforma digital criada para potencializar o aprendizado com inteligência artificial,
        sem abrir mão do que há de mais humano na educação: o papel dos educadores.
      </p>
      <p>
        Mais do que um sistema de gestão, é um ambiente inteligente de apoio ao ensino, que oferece dados e insights para
        fortalecer as decisões pedagógicas — sempre respeitando a sensibilidade, a experiência e a intuição de quem ensina.
      </p>
      <p>
        Projetado para atender instituições de ensino médio, preparatórios, graduação, pós-graduação e também programas de
        treinamento e desenvolvimento em empresas, o The Simon Project se adapta com inteligência e sensibilidade a diferentes
        contextos educacionais — sempre com o compromisso de unir tecnologia, propósito e valorização das pessoas.
      </p>

      <hr className="simon-divider" />

      <h2>Por que "Simon"?</h2>

      <div className="simon-row">
        <p className="simon-half-text">
          O nome The Simon Project é uma homenagem a Herbert A. Simon, Prêmio Nobel de Economia (1978) e um dos pensadores mais
          influentes do século XX. Simon foi pioneiro nos estudos sobre tomada de decisão em ambientes complexos, formulador do
          conceito de racionalidade limitada, e um dos fundadores da inteligência artificial como campo de estudo.
        </p>
        <img src={simon} alt="Herbert Simon" className="simon-inline-image" />
      </div>

      <p>
        Sua abordagem multidisciplinar — unindo economia, psicologia, ciência política e ciência da computação — foi decisiva para
        o desenvolvimento de sistemas capazes de simular e apoiar decisões humanas. Inspirado por essa visão, o The Simon Project
        incorpora mecanismos de IA voltados ao aprendizado, auxiliando educadores e gestores na personalização de trilhas, na análise
        de desempenho e na tomada de decisões estratégicas no ambiente educacional.
      </p>
    </div>
  );
};

export default TheSimonProject;
